module.exports = __webpack_public_path__ + "img/pembayaran.510f4bb4.png";